import { css } from 'styled-components'
import { Color } from '../color'

export const shadowCtaCss = css`
  height: 60px;
  padding: 0 40px;

  position: relative;

  border-radius: 30px;
  background-color: ${Color.purple_500};
  box-shadow: 5px 5px 0 0 ${Color.purple_600};
  z-index: 5;

  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0.03em;

  :hover {
    top: 5px;
    left: 5px;

    background-color: ${Color.purple_600};
    box-shadow: none;
  }
`
